import PropTypes from 'prop-types'
import React from 'react'

import { Arrow } from './styles'

const FaqBlockArrow = React.forwardRef(({ colorTheme, top }, ref) => {
  return <Arrow ref={ref} colorTheme={colorTheme} style={{ top: `${top}px` }} />
})

FaqBlockArrow.propTypes = {
  colorTheme: PropTypes.string.isRequired,
  top: PropTypes.number.isRequired,
}

export default FaqBlockArrow
